export enum EventGroup {
  All = -1,
  Scheduled = -2,
  DontWork = -3,
  ClockAndSched = -6,
  Custom = 0,
}
